import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, apiFetch } from 'API/apiClient';
import type { IDrawing } from 'types/IDrawing';
import type { RootState } from 'store/store';

interface FetchDrawingsParams {
  drawingBaseId?: number;
  lotteryId?: number;
}

export const fetchDrawings = createAsyncThunk<IDrawing[], FetchDrawingsParams | undefined, { rejectValue: ApiError; state: RootState }>('drawings/fetchAll', async (params, { rejectWithValue }) => {
  const searchParams = new URLSearchParams();
  if (params?.drawingBaseId) searchParams.set('drawingBaseId', String(params.drawingBaseId));
  if (params?.lotteryId) searchParams.set('lotteryId', String(params.lotteryId));
  const query = searchParams.toString();
  const url = query ? `/drawing?${query}` : '/drawing';
  return await apiFetch<IDrawing[]>(url, {}, rejectWithValue);
});

export const fetchDrawing = createAsyncThunk<IDrawing, number, { rejectValue: ApiError; state: RootState }>('drawings/fetchOne', async (id, { rejectWithValue }) => {
  return await apiFetch<IDrawing>(`/drawing/${id}`, {}, rejectWithValue);
});

export const createDrawing = createAsyncThunk<IDrawing, Partial<IDrawing>, { rejectValue: ApiError; state: RootState }>('drawings/create', async (data, { rejectWithValue }) => {
  return await apiFetch<IDrawing>('/drawing', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }, rejectWithValue);
});

export const updateDrawing = createAsyncThunk<IDrawing, { id: number; data: Partial<IDrawing> }, { rejectValue: ApiError; state: RootState }>('drawings/update', async ({ id, data }, { rejectWithValue }) => {
  return await apiFetch<IDrawing>(`/drawing/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }, rejectWithValue);
});

export const deleteDrawing = createAsyncThunk<void, number, { rejectValue: ApiError; state: RootState }>('drawings/delete', async (id, { rejectWithValue }) => {
  return await apiFetch<void>(`/drawing/${id}`, { method: 'DELETE' }, rejectWithValue);
});
